export const contracts = {
  en: {
    weekendDays: "Weekend days",
    weekendFollowsBranch: "Follows the branch",
    weekendOverridden: "This contract sets its own",
    weekendHint: "Leave as the branch's unless this person rests on different days. Only a real difference is stored, so changing the branch's weekend still moves everybody who follows it.",
    identity: "Personal details",
    identityNote: "These belong to the person and stay with them across every contract. This is the only place they can be corrected.",
    saveIdentity: "Save personal details",
    offboarding: "Offboarding",
    offboardingNote: "The paperwork that closes out this employment. Check the figures below before issuing the termination letter or final settlement from the Documents page.",
    offboardingGenerateNote: "The termination letter and final settlement themselves are generated from the Documents page, using the same figures as this preview.",
    settlementPreview: "Settlement",
    netSettlement: "Net settlement",
    settlementNegative: "This settlement is negative: the employee owes more than they are due. The document will show it as such.",
    settlementBasis: "Includes {days} days of accrued leave, calculated to {lastDay}, and salary for the days worked in the final month. Outstanding advances are already deducted.",
    backToEmployee: "Back to employee",
    historicalNote: "This contract is closed. Its records are kept as they were; a rehire is a new contract.",
    actions: "Actions",
    terms: "Employment terms",
    history: "History",
    activate: "Activate",
    activateTitle: "Activate this contract?",
    activateBody: "Employment begins: the role takes effect, the leave policy is created, and the person appears in the directory.",
    renew: "Renew",
    renewTitle: "Renew contract",
    renewFrom: "The renewal must start the day after {date}, so there is no gap in employment.",
    renewNoEnd: "The current contract has no end date. The renewal starts on the date you choose.",
    renewConfirm: "The current contract is superseded and the replacement becomes active. This cannot be undone from here.",
    terminate: "Terminate",
    terminateTitle: "Terminate employment",
    terminateWarning: "This ends the employment relationship. The leave policy closes, the end-of-service award is fixed, and outstanding loans are netted.",
    terminateConfirm: "This cannot be undone. The contract and its records become historical.",
    terminateWord: "TERMINATE",
    lastWorkingDay: "Last working day",
    access: "Login access",
    hireDoneTitle: "Hired. One thing left.",
    hireDoneNote: "The employee, the contract and the login account were all created. Deal with the password below before you leave this page.",
    hireDoneOpen: "Open the employee",
    credentialsTitle: "Sign-in details — shown once",
    credentialsShownOnce: "The temporary password is stored as a one-way hash and cannot be read back. This is the only time it is shown. Send it now, copy it, or issue a new one later.",
    credentialsSend: "Email these details to {address}",
    credentialsSent: "Sent to {address}.",
    credentialsNoEmail: "This person has no email address on file, so the details cannot be emailed. Add one on the contract, or copy the password and hand it over yourself.",
    credentialsCopy: "Copy",
    credentialsCopied: "Copied",
    accessPasswordIssued: "A temporary password is generated when the account is created, and shown once. You do not choose one.",
    accessNone: "This person has no login yet.",
    accessRename: "Change username",
    accessRenamed: "Saved.",
    accessRenameNote: "Latin letters, numbers, dots, underscores or hyphens — no spaces. Changing it changes only what they type to sign in: the password, the account's status and any session they already have are untouched.",
    accessCreate: "Create login",
    accessActive: "Active",
    accessDisabled: "Disabled",
    accessReset: "Reset password",
    accessDisable: "Disable login",
    accessEnable: "Enable login",
    accessResetNote: "Resetting issues a new temporary password and shows it once. Every open session on the account ends, and they are asked to choose their own at the next sign-in.",
    hireTitle: "Hire",
    hireIntro: "Identity and employment terms are entered together and saved as one action. Nothing is created until every part succeeds.",
    hireWho: "Who is being hired",
    hireMode: "This is",
    hireModeNew: "Somebody new",
    hireModeExisting: "Somebody already in the directory",
    hireExistingNote: "For a rehire, or for anybody in the directory who has no contract yet. The contract attaches to their existing record, so their history, documents and audit trail stay in one place.",
    hireIdentity: "Personal details",
    hireIdentityNote: "These belong to the person and stay with them across every contract they hold.",
    hireEmployment: "Employment terms",
    hireEmploymentNote: "These belong to this contract. Changing them later means changing the contract.",
    hireAccess: "Activation and access",
    hireActivate: "Activate this contract now",
    hireActivateNote: "Employment starts immediately: the role takes effect, the leave policy is created, and the person appears in the directory.",
    hireDraftNote: "Saved as a draft. Employment does not start and no leave accrues until the contract is activated.",
    hireCreateLogin: "Create a login for this person",
    hireUsername: "Username",
    hireTemporaryPassword: "Temporary password",
    hireLoginNote: "They will be asked to choose their own password the first time they sign in.",
    hireSubmit: "Hire",
    hireConfirmTitle: "Complete this hire?",
    hireConfirmActive: "The contract will be activated and employment will begin. This creates the leave policy and grants the role you selected.",
    hireConfirmDraft: "The contract will be saved as a draft. Employment does not begin until you activate it.",

    contractType: "Contract type",
    startDate: "Start date",
    endDate: "End date",
    jobTitleAr: "Job title (Arabic)",
    pay: "Pay",
    basicSalary: "Basic salary",
    housingAllowance: "Housing allowance",
    transportAllowance: "Transport allowance",
    otherAllowances: "Other allowances",
    otherAllowancesNote: "Paid every month, on top of the salary above, and named on the salary certificate. For a one-off payment this month only, use + Add item on the payroll run instead.",
    otherAllowanceAdd: "+ Add allowance",
    otherAllowanceName: "What it is for",
    otherAllowancePlaceholder: "Phone allowance",
    otherAllowanceAmount: "Amount",
    otherAllowanceRemove: "Remove",
    transferMethod: "Salary transfer method",
    iban: "IBAN",
    bankName: "Bank",
    gosiEligible: "Subject to GOSI",
    gosiRate: "GOSI rate",
    "gosiRate.rate_9_75": "9.75%",
    "gosiRate.rate_10_25": "10.25%",
    "gosiRate.rate_10_75": "10.75%",
    termsSection: "Leave and notice",
    annualLeaveDays: "Annual leave days",
    statutoryDefault: "Statutory default",
    noticePeriodDays: "Notice period (days)",
    probationEnabled: "Include a probation period",
    probationDays: "Probation (days)",
  },
  ar: {
    weekendDays: "أيام الراحة",
    weekendFollowsBranch: "حسب الفرع",
    weekendOverridden: "هذا العقد يحدد أيامه",
    weekendHint: "اتركها كما في الفرع إلا إذا كانت راحة هذا الموظف في أيام مختلفة. لا يُحفظ إلا الاختلاف الفعلي، لذلك يبقى تغيير عطلة الفرع سارياً على من يتبعه.",
    identity: "البيانات الشخصية",
    identityNote: "هذه البيانات تخص الشخص وتبقى معه في كل عقوده. هذا هو المكان الوحيد لتصحيحها.",
    saveIdentity: "حفظ البيانات الشخصية",
    offboarding: "إنهاء الخدمة",
    offboardingNote: "المستندات التي تُغلق هذه العلاقة الوظيفية. راجع الأرقام أدناه قبل إصدار خطاب إنهاء الخدمة أو التصفية النهائية من صفحة المستندات.",
    offboardingGenerateNote: "يتم إصدار خطاب إنهاء الخدمة والتصفية النهائية من صفحة المستندات، باستخدام نفس الأرقام الموضحة في هذه المعاينة.",
    settlementPreview: "التصفية",
    netSettlement: "صافي التصفية",
    settlementNegative: "التصفية بالسالب: المستحق على الموظف أكبر مما له. سيظهر ذلك في المستند.",
    settlementBasis: "تشمل {days} يوم إجازة مستحقة محتسبة حتى {lastDay}، وراتب أيام العمل في الشهر الأخير. السلف القائمة مخصومة مسبقاً.",
    backToEmployee: "العودة إلى الموظف",
    historicalNote: "هذا العقد منتهٍ. تُحفظ سجلاته كما هي، وإعادة التوظيف تتم بعقد جديد.",
    actions: "الإجراءات",
    terms: "شروط التوظيف",
    history: "السجل",
    activate: "تفعيل",
    activateTitle: "تفعيل هذا العقد؟",
    activateBody: "يبدأ التوظيف: تسري الصلاحية، وتُنشأ سياسة الإجازات، ويظهر الموظف في الدليل.",
    renew: "تجديد",
    renewTitle: "تجديد العقد",
    renewFrom: "يجب أن يبدأ التجديد في اليوم التالي لـ {date} حتى لا تكون هناك فجوة في التوظيف.",
    renewNoEnd: "العقد الحالي بدون تاريخ انتهاء. يبدأ التجديد في التاريخ الذي تختاره.",
    renewConfirm: "سيتم إنهاء العقد الحالي كعقد سابق ويصبح العقد البديل ساريًا. لا يمكن التراجع عن ذلك من هنا.",
    terminate: "إنهاء الخدمة",
    terminateTitle: "إنهاء الخدمة",
    terminateWarning: "يؤدي هذا إلى إنهاء علاقة العمل: تُغلق سياسة الإجازات، ويُحتسب مكافأة نهاية الخدمة، وتُخصم السلف القائمة.",
    terminateConfirm: "لا يمكن التراجع عن هذا الإجراء. يصبح العقد وسجلاته تاريخية.",
    terminateWord: "TERMINATE",
    lastWorkingDay: "آخر يوم عمل",
    access: "حساب الدخول",
    hireDoneTitle: "تم التوظيف. بقي أمر واحد.",
    hireDoneNote: "أُنشئ الموظف والعقد وحساب الدخول. تعامل مع كلمة المرور أدناه قبل مغادرة هذه الصفحة.",
    hireDoneOpen: "فتح ملف الموظف",
    credentialsTitle: "بيانات الدخول — تُعرض مرة واحدة",
    credentialsShownOnce: "تُحفظ كلمة المرور المؤقتة مشفّرة بشكل غير قابل للعكس ولا يمكن استرجاعها. هذه هي المرة الوحيدة التي تُعرض فيها. أرسلها الآن، أو انسخها، أو أصدر كلمة مرور جديدة لاحقاً.",
    credentialsSend: "إرسال البيانات إلى {address}",
    credentialsSent: "أُرسلت إلى {address}.",
    credentialsNoEmail: "لا يوجد بريد إلكتروني لهذا الموظف، لذا لا يمكن إرسال البيانات بالبريد. أضف البريد في العقد، أو انسخ كلمة المرور وسلّمها بنفسك.",
    credentialsCopy: "نسخ",
    credentialsCopied: "تم النسخ",
    accessPasswordIssued: "تُولَّد كلمة مرور مؤقتة عند إنشاء الحساب وتُعرض مرة واحدة. لا تختارها بنفسك.",
    accessNone: "لا يوجد حساب دخول لهذا الموظف.",
    accessRename: "تغيير اسم المستخدم",
    accessRenamed: "تم الحفظ.",
    accessRenameNote: "حروف لاتينية أو أرقام أو نقطة أو شرطة سفلية أو شرطة — بدون مسافات. التغيير يطال اسم الدخول فقط: كلمة المرور وحالة الحساب وأي جلسة مفتوحة تبقى كما هي.",
    accessCreate: "إنشاء حساب",
    accessActive: "فعّال",
    accessDisabled: "معطّل",
    accessReset: "إعادة تعيين كلمة المرور",
    accessDisable: "تعطيل الحساب",
    accessEnable: "تفعيل الحساب",
    accessResetNote: "إعادة التعيين تُصدر كلمة مرور مؤقتة جديدة وتعرضها مرة واحدة. تنتهي كل جلسة مفتوحة على الحساب، ويُطلب منه اختيار كلمة مرور خاصة به عند تسجيل الدخول التالي.",
    hireTitle: "توظيف",
    hireIntro: "تُدخل البيانات الشخصية وشروط التوظيف معاً وتُحفظ في إجراء واحد. لا يتم إنشاء أي سجل إلا بنجاح جميع الأجزاء.",
    hireWho: "من يتم توظيفه",
    hireMode: "الحالة",
    hireModeNew: "موظف جديد",
    hireModeExisting: "موظف موجود في السجل",
    hireExistingNote: "لإعادة التوظيف، أو لأي موظف في السجل ليس لديه عقد بعد. سيُربط العقد بسجله الحالي، بحيث يبقى تاريخه ومستنداته وسجل التدقيق في مكان واحد.",
    hireIdentity: "البيانات الشخصية",
    hireIdentityNote: "هذه البيانات تخص الشخص وتبقى معه في كل عقوده.",
    hireEmployment: "شروط التوظيف",
    hireEmploymentNote: "هذه البيانات تخص هذا العقد. تعديلها لاحقاً يتم من خلال العقد.",
    hireAccess: "التفعيل والوصول",
    hireActivate: "تفعيل العقد الآن",
    hireActivateNote: "يبدأ التوظيف فوراً: تسري الصلاحية، وتُنشأ سياسة الإجازات، ويظهر الموظف في الدليل.",
    hireDraftNote: "سيُحفظ كمسودة. لا يبدأ التوظيف ولا تُحتسب الإجازات حتى يتم تفعيل العقد.",
    hireCreateLogin: "إنشاء حساب دخول لهذا الموظف",
    hireUsername: "اسم المستخدم",
    hireTemporaryPassword: "كلمة مرور مؤقتة",
    hireLoginNote: "سيُطلب منه اختيار كلمة مرور خاصة به عند أول تسجيل دخول.",
    hireSubmit: "توظيف",
    hireConfirmTitle: "إتمام التوظيف؟",
    hireConfirmActive: "سيتم تفعيل العقد ويبدأ التوظيف، مع إنشاء سياسة الإجازات ومنح الصلاحية المحددة.",
    hireConfirmDraft: "سيُحفظ العقد كمسودة. لا يبدأ التوظيف حتى تقوم بتفعيله.",

    contractType: "نوع العقد",
    startDate: "تاريخ البداية",
    endDate: "تاريخ الانتهاء",
    jobTitleAr: "المسمى الوظيفي (بالعربية)",
    pay: "الأجر",
    basicSalary: "الراتب الأساسي",
    housingAllowance: "بدل السكن",
    transportAllowance: "بدل النقل",
    otherAllowances: "بدلات أخرى",
    otherAllowancesNote: "تُصرف شهرياً فوق الراتب أعلاه، وتظهر باسمها في شهادة الراتب. أما المبلغ لمرة واحدة هذا الشهر فيُضاف من زر + في مسير الرواتب.",
    otherAllowanceAdd: "+ إضافة بدل",
    otherAllowanceName: "نوع البدل",
    otherAllowancePlaceholder: "بدل هاتف",
    otherAllowanceAmount: "المبلغ",
    otherAllowanceRemove: "حذف",
    transferMethod: "طريقة تحويل الراتب",
    iban: "رقم الآيبان",
    bankName: "البنك",
    gosiEligible: "خاضع للتأمينات الاجتماعية",
    gosiRate: "نسبة التأمينات الاجتماعية",
    "gosiRate.rate_9_75": "9.75٪",
    "gosiRate.rate_10_25": "10.25٪",
    "gosiRate.rate_10_75": "10.75٪",
    termsSection: "الإجازات والإشعار",
    annualLeaveDays: "أيام الإجازة السنوية",
    statutoryDefault: "الافتراضي النظامي",
    noticePeriodDays: "مدة الإشعار (أيام)",
    probationEnabled: "تضمين فترة تجربة",
    probationDays: "فترة التجربة (أيام)",
  },
} as const;
